import { SpacingSizes } from '@/utils/constants';

const resolveSpacingSize = ({ rawVal }: any): SpacingSizes => {
  if (/^none$/i.test(rawVal)) {
    return SpacingSizes.none;
  }

  // Support for legacy 'half' (due to already existing components on the CMS)
  if (/half|small/i.test(rawVal)) {
    return SpacingSizes.small;
  }

  if (/large/i.test(rawVal)) {
    return SpacingSizes.large;
  }

  // Support for legacy 'standard' (due to already existing components on the CMS)
  return SpacingSizes.medium;
};

export default resolveSpacingSize;
